import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StripeSearchOptions } from '../models/stripe/stripe-search-options';

@Injectable({
  providedIn: 'root'
})
export class GtStripeService {

  url: string = environment.api.endpoint;
  identityUrl: string = environment.api.identity;

  constructor(private http: HttpClient) { }

  getCustomer(options: StripeSearchOptions): any {
    return this.http.post(`${this.identityUrl}/account/customer`, options);
  }

  getCustomerSubscription(id: string): any {
    return this.http.get(`${this.identityUrl}/account/customer/subscription/${id}`);
  }

  getProducts(data): any {
    return this.http.get(`${this.identityUrl}/stripeproduct`, {params: data});
  }

  getProductById(id: string): any{
    return this.http.get(`${this.identityUrl}/stripeproduct/${id}`);
  }

  getCustomersCurrentProduct(data): any {
    return this.http.get(`${this.identityUrl}/stripeproduct/current/customer`, {params: data});
  }

  getAccountById(id: string): any {
    return this.http.get(`${this.identityUrl}/stripeaccount/${id}`);
  }

  getAccountLoginLink(id): any {
    return this.http.get(`${this.identityUrl}/stripeaccount/${id}/loginlink`);
  }

  getAccountLink(): any{
    return this.http.get(`${this.identityUrl}/stripeaccount/accountlink`);
  }

  createAccountSession(id: string): any {
    return this.http.get(`${this.identityUrl}/stripeaccount/accountsession/create/${id}`);
  }

  onboardStripeConnectAccount(data): any {
    return this.http.post(`${this.identityUrl}/stripeaccount/accountlink/create`, data);
  }

  getConnectAccountInvoices(data: any){
    return this.http.post(`${this.identityUrl}/stripeaccount/invoices`, data);
  }

  createPaymentIntent(data): any {
    return this.http.post(`${this.identityUrl}/stripepaymentintent/create`, data)
  }

  cancelPaymentIntent(data): any {
    return this.http.post(`${this.identityUrl}/stripepaymentintent/cancel`, data)
  }

  updatePaymentIntent(data): any {
    return this.http.post(`${this.identityUrl}/stripepaymentintent/update`, data)
  }

  createSetupIntent(data): any {
    return this.http.post(`${this.identityUrl}/stripesetupintent/create`, data)
  }

  confirmSetupIntent(id: string, data): any {
    return this.http.post(`${this.identityUrl}/stripesetupintent/confirm/${id}`, data)
  }

  cancelSetupIntent(id: string): any {
    return this.http.get(`${this.identityUrl}/stripesetupintent/cancel/${id}`)
  }

  createSubscription(data): any {
    return this.http.post(`${this.identityUrl}/stripesubscription/create`, data);
  }

  updateSubscription(data): any {
    return this.http.post(`${this.identityUrl}/stripesubscription/update`, data);
  }
  
  getTerminalReaders(id: string, data: any){
    return this.http.post(`${this.identityUrl}/stripeterminal/readers/account/${id}`, data);
  }

  createTerminalReader(id: string, data: any){
    return this.http.post(`${this.identityUrl}/stripeterminal/reader/create/${id}`, data);
  }

  deleteTerminalReader(data: any){
    return this.http.post(`${this.identityUrl}/stripeterminal/reader/delete`, data);
  }

  getTerminalReaderById(id: string, accountId: string): any{
    return this.http.get(`${this.identityUrl}/stripeterminal/reader/${id}`, {
      params: new HttpParams().set('accountId', accountId)
    });
  }

  createTerminalLocation(id: string, data: any){
    return this.http.post(`${this.identityUrl}/stripeterminal/location/create/${id}`, data);
  }

  deleteTerminalLocation(data: any){
    return this.http.post(`${this.identityUrl}/stripeterminal/location/delete`, data);
  }

  getTerminalLocations(id: string, data: any){
    return this.http.post(`${this.identityUrl}/stripeterminal/locations/account/${id}`, data);
  }
}
